import React from 'react';
import * as Yup from 'yup';

import Municipality, {
  MunicipalityEditableFields,
} from '../../../types/Municipality';

import handleApiErrors from '../../../lib/apiClient/handleErrors';
import updateMunicipality from '../../../lib/apiClient/municipalities/update';
import deleteMunicipality from '../../../lib/apiClient/municipalities/delete';

import InputCell from '../../common/ui/Table/Cells/InputCell';
import Row from '../../common/ui/Table/Row';

interface Props {
  municipality: Municipality;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;
}

const MunicipalitiesTableRow = ({
  municipality: { id, name },
  unauthorizedCallback,
  showError,
}: Props) => {
  const update = (municipality: MunicipalityEditableFields) => {
    handleApiErrors(
      updateMunicipality(id, municipality),
      unauthorizedCallback,
      showError,
    );
  };

  const destroy = () =>
    handleApiErrors(deleteMunicipality(id), unauthorizedCallback, showError);

  const nameValidationSchema = Yup.string().required(
    'Название муниципалитета не может быть пустым',
  );

  return (
    <Row destroy={destroy}>
      <InputCell
        value={name}
        onConfirm={(value) => update({ name: value })}
        validationSchema={nameValidationSchema}
        onValidationFailure={(error) => showError(error)}
      />
    </Row>
  );
};

export default MunicipalitiesTableRow;
